<template>
<div class="container">
<b-row v-if="!isLoading">
<h5>
	<label for="desde">Desde</label> &nbsp;
	<input type="date" name="" id="desde" v-model="desde" @click="desde='';hasta='';pais='';paises=false;muestreLista=false">&nbsp; 
	<label for="hasta">Hasta</label> &nbsp;
	<input type="date" name="" id="hasta" v-model="hasta" @click="hasta='';pais='';paises=false" @input="f_seleccione_pais()">&nbsp; 
	<label v-if="paises">País</label>
	<select v-if="paises" v-model="pais" @click="f_restaure_botones()">
		<option
			v-for="(item, idx) in listPaises"
			:key="idx"
			:value="item.pais">
			{{item.pais}}
		</option>
	</select>
	<span v-if="pais && paises">
		<label v-if="desde && hasta" >Consulta por:</label> &nbsp;
		<label v-if="desde && hasta" for="Fecha">Fecha</label> &nbsp;
		<input v-if="desde && hasta" type="checkbox" id="Fecha" value="Fecha" v-on:click="uncheck(1)" > &nbsp; &nbsp;
		<label v-if="desde && hasta" for="Lider">Lider</label> &nbsp;
		<input v-if="desde && hasta" type="checkbox" id="Lider" value="Lider" v-on:click="uncheck(2)"> &nbsp;&nbsp;		
		<label v-if="desde && hasta" for="Usuario">Usuario</label> &nbsp;
		<input v-if="desde && hasta" type="checkbox" id="Usuario" value="Usuario" v-on:click="uncheck(3)"> &nbsp;&nbsp;
	</span>
</h5>
<b-container v-if="muestreLista">
	<md-table v-model="listFacturas" md-card md-fixed-header @md-selected="f_muestra_facturas">
	<md-table-toolbar>
		<h1 class="md-title"><b><i>{{f_titulo()}}</i></b></h1>
	</md-table-toolbar>
	<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
		<md-table-cell :md-label="labels.fecha" class="text-left border">{{item.fecha_factura}}</md-table-cell>
		<md-table-cell :md-label="labels.estado" class="text-left border">{{f_estado(item.estado)}}</md-table-cell>
		<md-table-cell v-if="Lider" :md-label="labels.lider" class="text-left border">{{item.id_lider}}</md-table-cell>
		<md-table-cell v-if="Lider" :md-label="labels.lider_nombre" class="text-left border">{{item.name}}</md-table-cell>
		<md-table-cell v-if="Usuario" :md-label="labels.usuario" class="text-left border">{{item.id_usuario}}</md-table-cell>
		<md-table-cell v-if="Usuario" :md-label="labels.usuario_nombre" class="text-left border">{{item.name}}</md-table-cell>
		<md-table-cell :md-label="labels.cantidad" class="text-left border">{{item.cantidad}}</md-table-cell>
		<md-table-cell :md-label="labels.items" class="text-left border">{{item.items}}</md-table-cell>
	</md-table-row>
	</md-table>
</b-container>
<md-dialog :md-active.sync="muestreFacturas">
	<md-dialog-title class="text-center"><h3><b><i>{{titulo_estado}}</i></b>
	</h3></md-dialog-title>
	<md-dialog-content>
		<md-table v-model="listFacturasCliente" md-card md-fixed-header @md-selected="f_muestra_detalle">
			<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
				<md-table-cell :md-label="labels.fecha" class="text-left border">{{item.fecha_factura}}</md-table-cell>
				<md-table-cell :md-label="labels.factura" class="text-left border">{{item.factura}}</md-table-cell>
				<md-table-cell :md-label="labels.proveedor" class="text-left border">{{item.nombre}}</md-table-cell>
				<md-table-cell :md-label="labels.cargado" class="text-right border">{{f_formato_fecha(item.createdAt)}}</md-table-cell>
				<md-table-cell :md-label="labels.cargadot" class="text-right border">{{f_compare_fecha(item.createdAt)}}</md-table-cell>
				<md-table-cell v-if="item.estado!==null" :md-label="labels.actualizado" class="text-right border">{{f_compare_fecha(item.updatedAt)}}</md-table-cell>
				<md-table-cell v-if="item.termina_contab===null && item.estado!==null" :md-label="labels.iniciado" class="text-right border">{{f_compare_fecha(item.inicia_contab)}}</md-table-cell>
				<md-table-cell v-if="item.termina_contab!==null" :md-label="labels.iniciado" class="text-right border">{{f_compare_2_fechas(item.createdAt,item.inicia_contab)}}</md-table-cell>
				<md-table-cell v-if="item.termina_contab!==null && item.estado!==null" :md-label="labels.terminado" class="text-right border">{{f_compare_2_fechas(item.inicia_contab,item.termina_contab)}}</md-table-cell>
				<md-table-cell v-if="item.termina_contab===null && item.estado!== null" :md-label="labels.terminado" class="text-right border">{{f_compare_fecha(item.termina_contab)}}</md-table-cell>
			</md-table-row>
		</md-table>
		<md-dialog-actions>
			<md-button class="md-accent" @click="muestreFacturas = false">Cerrar</md-button>
		</md-dialog-actions>
	</md-dialog-content>
</md-dialog>
<md-dialog :md-active.sync="muestreDetalleFacturas">
	<md-dialog-content>
		<md-table >
			<md-table-row >
				<md-table-cell class="text-right border">Factura</md-table-cell>
				<md-table-cell class="text-left border">{{factura.fecha_factura}}</md-table-cell>
				<md-table-cell class="text-left border">{{factura.factura}}</md-table-cell>
			</md-table-row>
			<md-table-row >
				<md-table-cell class="text-right border">Identificación</md-table-cell>
				<md-table-cell class="text-left border">{{factura.identificacion}}</md-table-cell>
				<md-table-cell class="text-left border">{{factura.nombre}}</md-table-cell>
			</md-table-row>
			<md-table-row >
				<md-table-cell class="text-right border">Pedido/Remision</md-table-cell>
				<md-table-cell class="text-left border">{{factura.pedido}}</md-table-cell>
				<md-table-cell v-if="factura.remision != 'NULL'" class="text-left border">{{factura.remision}}</md-table-cell>
			</md-table-row>
			<md-table-row v-if="factura.categoria0 != 'NULL'">
				<md-table-cell class="text-right border">Impuesto(s)</md-table-cell>
				<md-table-cell class="text-right border">{{factura.categoria0}}</md-table-cell>
				<md-table-cell class="text-right border">{{factura.impuesto0}}</md-table-cell>
			</md-table-row>
			<md-table-row v-if="factura.categoria1 != 'NULL'">
				<md-table-cell class="text-right border"></md-table-cell>
				<md-table-cell class="text-right border">{{factura.categoria1}}</md-table-cell>
				<md-table-cell class="text-right border">{{factura.impuesto1}}</md-table-cell>
			</md-table-row>
			<md-table-row v-if="factura.categoria2 != 'NULL'">
				<md-table-cell class="text-right border"></md-table-cell>
				<md-table-cell class="text-right border">{{factura.categoria2}}</md-table-cell>
				<md-table-cell class="text-right border">{{factura.impuesto2}}</md-table-cell>
			</md-table-row>
			<md-table-row >
				<md-table-cell class="text-right border">Valor</md-table-cell>
				<md-table-cell class="text-right border"></md-table-cell>
				<md-table-cell class="text-right border">{{factura.valor}}</md-table-cell>
			</md-table-row>
			<md-table-row >
				<md-table-cell class="text-right border">Impuesto(s)</md-table-cell>
				<md-table-cell class="text-right border"></md-table-cell>
				<md-table-cell class="text-right border">{{factura.impuesto_total}}</md-table-cell>
			</md-table-row>
			<md-table-row >
				<md-table-cell class="text-right border">Total</md-table-cell>
				<md-table-cell class="text-right border"></md-table-cell>
				<md-table-cell class="text-right border">{{factura.valor_total}}</md-table-cell>
			</md-table-row>
			<md-table-row v-if="factura.id_lider >0">
				<md-table-cell class="text-right border">Lider</md-table-cell>
				<md-table-cell class="text-right border"></md-table-cell>
				<md-table-cell class="text-left border">{{f_usuario_nombre(factura.id_lider)}}</md-table-cell>
			</md-table-row>
			<md-table-row v-if="factura.id_usuario >0">
				<md-table-cell class="text-right border">Asignado</md-table-cell>
				<md-table-cell class="text-right border"></md-table-cell>
			<md-table-cell class="text-left border">{{f_usuario_nombre(factura.id_usuario)}}</md-table-cell>
			</md-table-row>
		</md-table>
		<md-dialog-actions>
			<md-button class="md-accent" @click="muestreDetalleFacturas = false">Cerrar</md-button>
		</md-dialog-actions>
	</md-dialog-content>
</md-dialog>
</b-row>
</div>
</template>
<script>

import Seguimiento from "@/services/Seguimiento"
import User from "@/services/User"
import Estado from "@/services/Estados"

export default {
name:'Seguimiento',
data: () => ({
	isLoading: false,
	Fecha : false,
	Lider : false,
	Usuario : false,
	desde: '',
	hasta: '',
	opcion: 2,
	operacion: '',
	factura: '',
	pais: '',
	paises: false,
	titulo_factura: "",
	titulo_estado: "",
	users : [],
	listEstados : [],
	listPaises : [],
	listFacturas : [],
	listFacturasCliente : [],
	muestreLista: false,
	muestreFacturas: false,
	muestreDetalleFacturas: false,
}),
computed:{
labels(){
	if (this.$store.state._language == "es-ES") {
		return {
			title : "FACTURAS",
			factura : "Número Factura",
			fecha : "Fecha Factura",
			identificacion : "Número Identificación",
			proveedor : "Nombre Proveedor----------------------",
			cantidad : "Facturas",
			pedido : "Número Pedido",
			valor : "Valor Bruto",
			impuesto0 : "Impuesto0",
			categoria0 : "Categoria0",
			impuesto1 : "Impuesto1",
			categoria1 : "Categoria1",
			impuesto2 : "Impuesto2",
			categoria2 : "Categoria2",
			impuesto : "Total Impuesto",
			valor_total : "Total Factura",
			items : "Items",
			estado: "Estado",
			lider: "Lider",
			lider_nombre:   "Nombre del Lider",
			usuario: "Usuario",
			usuario_nombre: "Nombre del Usuario",
			cargado: "F Cargue",
			cargadot: "T Cargue",
			actualizado: "T Actual",
			iniciado: "T Inicio",
			terminado: "T Fin",
		}
	}else{
		return {
			title : "INVOICES",
			factura : "Invoice",
			fecha : "Date",
			identificacion : "Identification",
			proveedor : "Name",
			cantidad : "Invoices",
			pedido : "Order",
			valor : "Amount",
			impuesto0 : "Tax0",
			categoria0 : "Category0",
			impuesto1 : "Tax1",
			categoria1 : "Category1",
			impuesto2 : "Tax2",
			categoria2 : "Category2",
			impuesto : "Taxes",
			valor_total : "Total Amount",
			items : "Items",
			estado: "Condition",
			lider: "Leader",
			lider_nombre: "Leader Name",
			usuario: "User",
			usuario_nombre: "User Name",
			cargado: "Cargue",
			actualizado: "Actualizado",
			iniciado: "Begin",
			terminado: "End",
		}
	}
}
},
mounted(){
	User.getAllUsers(this.$store.state.userName)
	.then((result) => {
		this.users = result.data.users;
	})
	.catch((err) => {
		console.log(err)
	})
	Estado.leaEstados(false)
	.then((result) => {
		this.listEstados = result.data.listEstados;
	})
	.catch((err) => {
		console.log(err)
	})
},
methods:{
	f_titulo() {
		return "ESTADO DEL PROCESO DE CONTABILIZACION"
	},
	f_muestra_facturas(r_facturas) {
		this.muestreFacturas=true
		this.titulo_estado = "Estado: " + this.f_estado(r_facturas.estado)+" - "+this.pais
		Seguimiento.leaFacturasClienteEstado(this.pais,r_facturas.fecha_factura,r_facturas.estado,r_facturas.id_lider,r_facturas.id_usuario,this.desde,this.hasta)
		.then((res) => {
			this.listFacturasCliente = res.data.listFacturasCliente
		})
		.catch((err) => {
			console.log(err)
		})
		
	},
	f_muestra_detalle(r_factura) {
		this.factura=r_factura
		this.muestreDetalleFacturas=true
	},
	uncheck(opcion) {
		this.operacion = ''
		var checkbox1 = document.getElementById("Fecha");
		var checkbox2 = document.getElementById("Lider");
		var checkbox3 = document.getElementById("Usuario");
		checkbox1.checked=false;
		checkbox2.checked=false;
		checkbox3.checked=false;
		this.Fecha=false;
		this.Lider=false;
		this.Usuario=false;
		if (opcion == 1) {
			checkbox1.checked=true;
			this.Fecha=true;
			this.operacion="fecha"
		}
		if (opcion == 2) {
			checkbox2.checked=true;
			this.Lider=true;
			this.operacion="lider"
		}
		if (opcion == 3) {
			checkbox3.checked=true;
			this.Usuario=true;
			this.operacion="usuario"
		}
		Seguimiento.leaFacturasEstado(this.operacion,this.pais,this.desde,this.hasta)
		.then((res) => {
			this.listFacturas = res.data.listFacturas
			this.muestreLista = true
		})
		.catch((err) => {
			console.log(err)
		})
	},
	f_estado(estado) {
		if	(estado == null) {
			return "Por asignar"
		}
		const v_estado = this.listEstados.find((r_estado) => r_estado.estado==estado)
		return v_estado.descripcion
	},
	f_seleccione_facturas() {
		this.muestreDetalleFacturas=false
		this.muestreFacturas=false
		this.muestreLista=true
	},
	f_seleccione_pais() {
		this.listPaises = []
		this.paises=true
		if	(this.desde && this.hasta) {
			Seguimiento.leaPaises(this.opcion,this.desde,this.hasta)
			.then((res) => {
				this.listPaises = res.data.listPaises
				this.pais=''
				if	(this.listPaises.lenght>0) {
					this.paises=true
				}
			})
			.catch((err) => {
				console.log(err)
			})
		}
	},
	f_restaure_botones() {
		this.Fecha=false
		this.Lider=false
		this.Usuario=false
		var checkbox1 = document.getElementById("Fecha")
		var checkbox2 = document.getElementById("Lider")
		var checkbox3 = document.getElementById("Usuario")
		checkbox1.checked=false
		checkbox2.checked=false
		checkbox3.checked=false
		this.muestreLista=false
	},
	f_usuario_nombre(p_id) {
		if	(p_id === null) {
			return ""
		}
		const v_usuario=this.users.find((r_usuario) => r_usuario.id==p_id
						)
		return v_usuario.name
	},
	f_formato_fecha(fecha) {
		if	(fecha === null) {
			return fecha
		}
		return fecha.substring(0,10)
	},
	f_compare_fecha(fecha) {
		if	(fecha === null) {
			return fecha
		}
		const v_hoy =  new Date()
		const v_fecha = new Date(fecha)


		var diff = Math.abs(v_hoy.getTime() - v_fecha.getTime())

		var dias = Math.floor(diff / (3600000*24))
		var horas = Math.floor(diff / 3600000)
		var minutos = Math.floor((diff % 3600000) / 60000)

		const elapsed =("00"+dias).slice(-2)+":"+("00" + horas).slice(-2)+":"+("00" + minutos).slice(-2)
		return elapsed
	},
	f_compare_2_fechas(fecha_inicial,fecha_final) {
		const v_fecha_inicial =  new Date(fecha_inicial)
		const v_fecha_final = new Date(fecha_final)


		var diff = Math.abs(v_fecha_final.getTime() - v_fecha_inicial.getTime())

		var dias = Math.floor(diff / (3600000*24))
		var horas = Math.floor(diff / 3600000)
		var minutos = Math.floor((diff % 3600000) / 60000)

		const elapsed =("00"+dias).slice(-2)+":"+("00" + horas).slice(-2)+":"+("00" + minutos).slice(-2)
		return elapsed
	},
}

}
</script>

<style>

</style>
